//@flow
import _ from 'lodash';
import * as React from 'react';
import SelectInput from '../../components/inputs/SelectInput';
import IconDelete from '../../images/icon_x_red.svg';
import { objectsConstants } from '../../_constants/objects.constants';
import { FormGroup } from '../FormGroup';
import InputViewEdit from '../inputs/InputViewEdit';
import PhoneInput from '../inputs/PhoneInput';

type Props = {
  entity: any,
  propName: string,
  index: number,
  viewMode: boolean,
  size: number,
  agendamentoMode?: boolean,
  errors?: any,
  onChange: (name: string, value: any) => void,
  removeItem: (index: number, entity: any) => void,
};

const normalizeDDI = (v) => '+' + String(v || '').replace(/\D/g, '');


export default class MultiTelefones extends React.Component<Props, State> {
  componentDidMount() {
    this.ensureDefaults();
  }

  componentDidUpdate(prevProps: Props) {
    // Quando o objeto desse índice muda, revalida defaults
    if (_.get(prevProps.entity, this.props.propName) !== _.get(this.props.entity, this.props.propName)) {
      this.ensureDefaults();
    }
  }

  ensureDefaults = () => {
    const { entity, propName, onChange, viewMode } = this.props;
    if (viewMode) return; // não mexe em modo de visualização

    const tel = _.get(entity, propName) || {};
    const ops = [];

    if (!tel.tipo) {
      ops.push(() => onChange(`${propName}.tipo`, 'CELULAR'));
    }
    if (!tel.codigoPais) {
      ops.push(() => onChange(`${propName}.codigoPais`, '+55'));
    }
    if (typeof tel.numero === 'undefined') {
      ops.push(() => onChange(`${propName}.numero`, ''));
    }

    if (ops.length) {
      // empurra pra próxima microtask pra evitar race com o mount do Formik
      Promise.resolve().then(() => ops.forEach(fn => fn()));
    }
  };

  render() {
    const { entity, propName, index, viewMode, size, agendamentoMode } = this.props;

    return (
      <React.Fragment>
        <FormGroup className={`col-5 ${agendamentoMode ? 'col-lg-3' : 'col-lg-3'}`}>
          <InputViewEdit
            label="Tipo do telefone"
            id={`tipoTelefone`}
            viewMode={viewMode}
            component={SelectInput}
            options={objectsConstants.TELEFONES}
            onChange={this.props.onChange}
            name={`${propName}.tipo`}
            value={_.get(entity, `${propName}.tipo`)} // sem defaultValue
            required={true}
            labelKey={'name'}
            valueKey={'value'}
            returnFullObject={false}
            erroMensagem={_.get(this.props.errors, `${propName}.tipo`)}
          />
        </FormGroup>

        <FormGroup className={`col-3 ${agendamentoMode ? 'col-lg-4' : 'col-lg-4'}`}>
          <InputViewEdit
            label="Código do país"
            id={`codigoPais${index}`}
            viewMode={viewMode}
            component={SelectInput}
            options={objectsConstants.CODIGOS_PAISES}
            onChange={(name, value) => {

              const v = typeof value === 'string' ? normalizeDDI(value) :
                value && value.value ? normalizeDDI(value.value) : value;
              this.props.onChange(name, v);
            }}
            name={`${propName}.codigoPais`}
            value={normalizeDDI(_.get(entity, `${propName}.codigoPais`) || '+55')}
            returnFullObject={false}
            required
            labelKey="name"
            valueKey="value"
            defaultValue={
              viewMode
                ? (() => {
                  const codigo = _.get(entity, `${propName}.codigoPais`);
                  const opt = (objectsConstants.CODIGOS_PAISES || []).find(
                    (o) => o.value === codigo
                  );
                  return opt ? opt.name : codigo;
                })()
                : undefined
            }
            erroMensagem={_.get(this.props.errors, `${propName}.codigoPais`)}
          />
        </FormGroup>

        <FormGroup className={`col-5 ${agendamentoMode ? 'col-lg-4' : 'col-lg-4'}`}>
          <InputViewEdit
            label="Número"
            viewMode={viewMode}
            component={PhoneInput}
            id={`Phone${index}`}
            name={`${propName}.numero`}
            placeholder="Somente números"
            value={_.get(entity, `${propName}.numero`)}
            onChange={(e) => {
              const { name, value } = e.currentTarget;
              this.props.onChange(name, value);
            }}
            // countryCode usa o valor atual; se ainda não existir, o PhoneInput cai no próprio fallback '+55'
            countryCode={
              _.get(entity, `${propName}.codigoPais`) !== undefined
                ? _.get(entity, `${propName}.codigoPais`)
                : '+55'
            }
            className={`${_.get(this.props, 'errors.telefone') ? 'error' : ''}`}
            required
            erroMensagem={_.get(this.props.errors, `${propName}.numero`)}
          />
        </FormGroup>

        <div
          className={`form-group col-2 ${agendamentoMode ? 'col-lg-1' : 'col-lg-1'
            } align-items-center justify-content-start ${viewMode ? 'd-none' : ' d-flex '}`}
        >
          <div
            className={`icon-delete d-flex align-items-end justify-content-start ${size === 1 || viewMode ? 'disabled' : ''}`}
            onClick={() => {
              this.props.removeItem(index, entity);
            }}
            disabled={size === 1}
          >
            <img src={IconDelete} alt="Excluir" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
